var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-ace-editor',{attrs:{"readonly":_vm.disabled,"snippets":true,"value":_vm.value,"height":_vm.height,"lang":"json"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }